/*
 * @Author: soji
 * @Description: 改单餐盒费计算
 * @Date: 2024-07-06 22:40:54
 */

import COM from './common';

const computePrice = (price)=> COM.computePrice(price,2);

let amendMealFeeHelper = {

  isSamePro(pro1 , pro2) {
    if(pro1.pid > 0 && pro2.pid > 0 && pro1.pid == pro2.pid) {
      return true
    }
    if(pro1.pid <= 0 && pro2.pid <= 0 && pro1.name == pro2.name) {
      return true
    }
    return false
  },

  countTotalMealFee (products, outMenuCartPros, originOrder, storeProducts, menuPros) {
    // 原订单餐盒费 + 不在订单的购物车商品【以外壳维度做对比】的餐盒费总合
    let originOrderMealFee = originOrder.mealFee;
    let notInOriginOrderProsMealFee = 0;

    let mulFeeModeAlreadyCountPros = []; // 按多份餐盒费模式且已经记过价的餐品

    let allPros = [...products, ...outMenuCartPros];

    let countProMealFee = (pro, originOrder, products, storeProducts, menuPros) => {
      let proMealFee = 0;

      // 在原订单的餐品就不计费【统一取原订单的总餐盒费】
      if(pro.outMenu || originOrder.orderProducts.some(orderPro => this.isSamePro(orderPro, pro))) {
        return 0;
      }

      let storePro = storeProducts[pro._key]; //在vuex cart.js的products中才存有餐盒费配置
      if(storePro) {
        // 多份餐盒费计价
        if(storePro.mealFeeMode == 1) {
          // 多份餐盒费保证只算一遍价
          if(!mulFeeModeAlreadyCountPros.some(noPro => this.isSamePro(noPro, pro))) {
            let totalProNum = 0; // 该餐品的总份数
            products.map(aPro => {if(aPro.pid === pro.pid) {totalProNum += aPro.num}})
            // mulMealFee 2 元 / part  3份
            let partCount = storePro.part == 0 ? 0 : Math.ceil(totalProNum / storePro.part)// 向上取整：剩下的装一个盒，不满一盒算一盒
            proMealFee = computePrice(Math.mul(partCount, storePro.mulMealFee) )
    
            mulFeeModeAlreadyCountPros.push(pro); 
          }

        }else {
          proMealFee = pro.num * (storePro.mealFee || 0);
        }
      }
      console.log('单个计算：', pro.name , proMealFee);
      return proMealFee;
    }

    allPros.map(pro => {
      notInOriginOrderProsMealFee += countProMealFee(pro, originOrder, products, storeProducts, menuPros)
    })

    return computePrice(originOrderMealFee + notInOriginOrderProsMealFee)
  },

  /**
   * 
   * @param {*} products orderNew.vue cartNew.vue 中的购物车数据【展开的】 [ { _key } ]
   * @param {*} outMenuCartPros 
   * @param {*} originOrder 
   * @param {*} storeProducts store - cart.js中多products数据【不展开的】 { _key: pro }
   * @returns 
   */
  countTotalMealFeeBack(products, outMenuCartPros, originOrder, storeProducts, menuPros) {
    let noChangeNAlreadyCountPros = []; // 无变化，且已经记过价的餐品
    let mulFeeModeAlreadyCountPros = []; // 按多份餐盒费模式且已经记过价的餐品

    let allPros = [...products, ...outMenuCartPros];
    let totalFee = 0;



    let countProMealFee = (pro, originOrder, products, storeProducts, menuPros) => {
      let proMealFee = 0;
      if(pro.originIsChange) {
        // 改了就按新餐单数据
        if(pro.outMenu) {
          // 容错：没改过/pid是0或-1，则取原订单餐盒费
          // if(pro.pid <= 0 || menuPros.some(menuPro => menuPro.pid == pro.pid)) {
          if(pro.pid <= 0 || !pro.originIsChange) {
            proMealFee = this.getProMealFeeFromOriginOrder(pro, originOrder).proTotalFee; // 原订单餐品餐盒费
          }else {
            proMealFee = this.getProMealFeeFromOriginOrder(pro, originOrder).preProFee * pro.num; // 原订单餐品单份餐盒费
          }
          
        }else {
          let storePro = storeProducts[pro._key]; //在vuex cart.js的products中才存有餐盒费配置
          if(storePro) {
            // 多份餐盒费计价
            if(storePro.mealFeeMode == 1) {
              // 多份餐盒费保证只算一遍价
              if(!mulFeeModeAlreadyCountPros.some(noPro => this.isSamePro(noPro, pro))) {
                let totalProNum = 0; // 该餐品的总份数
                products.map(aPro => {if(aPro.pid === pro.pid) {totalProNum += aPro.num}})
                // mulMealFee 2 元 / part  3份
                let partCount = storePro.part == 0 ? 0 : Math.ceil(totalProNum / storePro.part)// 向上取整：剩下的装一个盒，不满一盒算一盒
                proMealFee = computePrice(Math.mul(partCount, storePro.mulMealFee) )
    
                mulFeeModeAlreadyCountPros.push(pro); 
              }

            }else {
              proMealFee = pro.num * (storePro.mealFee || 0);
            }
          }

        }
      }else {
        // 没改就取原订单餐盒费总价
        // 保证一个餐品只算一次价格，避免重复计价
        if(!noChangeNAlreadyCountPros.some(noPro => this.isSamePro(noPro, pro))) {
          proMealFee = this.getProMealFeeFromOriginOrder(pro, originOrder).proTotalFee;
          noChangeNAlreadyCountPros.push(pro); 
        }

      }
      console.log('单个计算：', pro.name , proMealFee);
      return proMealFee;
    }

    allPros.map(pro => {
      totalFee += countProMealFee(pro, originOrder, products, storeProducts, menuPros)
    })

    console.log('餐盒费计算价格', totalFee);
    return computePrice(totalFee)
  },




  // 取原餐单餐品餐盒费
  getProMealFeeFromOriginOrder(pro, originOrder) {
    let fee = 0;
    let totalNum = 0; 
    /**
     * 容错餐品：
     * 如果有已改的标记，则直接取自身的totalMealFee
     * 如果没有已改的标记，则取总的
     */
    if(pro.outMenu) {
      for (let i = 0; i < originOrder.orderProducts.length; i++) {
        let oriPro = originOrder.orderProducts[i];
        if(this.isSamePro(oriPro, pro)) {
          if(oriPro.faultTolerantProductUpdateMealFee == 1) {
            fee = oriPro.totalMealFee;
            totalNum = oriPro.num
            break
          }else {
            fee += oriPro.totalMealFee;
            totalNum += oriPro.num;
          }
        }
      }
    }else {
      for (let i = 0; i < originOrder.orderProducts.length; i++) {
        let oriPro = originOrder.orderProducts[i];
        if(this.isSamePro(oriPro, pro)) {
          fee += oriPro.totalMealFee;
          totalNum += oriPro.num;
        }
      }
    }

    
    return {
      proTotalFee: computePrice(fee), // 原订单餐品总价
      preProFee: computePrice(fee / totalNum), // 原订单餐品单份价
    };
  },



}





export default amendMealFeeHelper;


// WEBPACK FOOTER //
// ./../../plugins/utils/amendMealFeeHelper.js